var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-screen h-screen flex items-center justify-center",staticStyle:{"background":"linear-gradient(180deg, #F6AB19 0%, rgba(246, 171, 25, 0) 100%)"}},[_c('img',{attrs:{"src":require("@/assets/images/sycamore_logo.svg"),"width":"30%"}})])
}]

export { render, staticRenderFns }